<template>
  <div>
    <Toolbar>
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.toolheadssub')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-toolheadsub-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.tool.inputquantity') }}</strong></td>
              <td>
                {{ $n(item['inputQuantity']) }}              </td>

              <td><strong>{{ $t('profile.tool.outputquantity') }}</strong></td>
              <td>
                {{ $n(item['outputQuantity']) }}              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.heater') }}</strong></td>
              <td>
                                    {{ item['heater'] }}
              </td>

              <td><strong>{{ $t('profile.tool.model') }}</strong></td>
              <td>
                                    {{ item['model'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.optionsubtool') }}</strong></td>
              <td>
                                    {{ item['optionSubTool'] }}
              </td>

              <td><strong>{{ $t('profile.tool.materialmedium') }}</strong></td>
              <td>
                    <span v-if="item['materialMedium']">{{ item['materialMedium'].name }}</span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.materialfeedspec') }}</strong></td>
              <td>
                    <span v-if="item['materialFeedSpec']">{{ item['materialFeedSpec'].name }}</span>
              </td>

              <td><strong>{{ $t('profile.tool.nozzletype') }}</strong></td>
              <td>
                    <span v-if="item['nozzleType']">{{ item['nozzleType'].name }}</span>
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.tools') }}</strong></td>
              <td>
                <ul>
                  <li v-for="tool in item['tools']" :key="tool.id">
                    {{ tool.name }}
                  </li>
                </ul>
              </td>

            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'ToolHeadSub';



export default {
  name: 'ToolHeadSubShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('toolheadsub', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('toolheadsub', ['find'])
  },
  methods: {
    ...mapActions('toolheadsub', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  },
};
</script>
